import { baseSiteEndPoint, buildHeaders, processResponse } from "./common";

export const apiDetailsCheckout = (getSellerID) =>
  fetch(`${baseSiteEndPoint}/sales/getsalecontext/${getSellerID}`, {
    method: "GET",
    headers: buildHeaders(),
  }).then(processResponse);

export const apiPayCharge = async (saleId, jsonData) => {
  try {
    const response = await fetch(`${baseSiteEndPoint}/sales/charge/${saleId}/pay`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(jsonData)
    });
    const data = await response.json();
    
    // Return data with response status for error handling
    return {
      ...data,
      httpStatus: response.status,
      httpStatusText: response.statusText
    };
  } catch (error) {
    throw error;
  }
}

export const apiPaymentStatus = async (saleId, paymentId) => {
  const response = await fetch(`${baseSiteEndPoint}/sales/charge/${saleId}/payment/${paymentId}/status`, {
    method: "GET",
    headers: buildHeaders(),
  });
  const data = await response.json();
  return { ...data, httpStatus: response.status };
}
